import { bureauTable } from "../data/BureauManage";
import { post } from "../utils/request";
import RegionSelect from "@/components/RegionSelect.vue";



export default {
  data() {
    return {
      showableComp: {
        addBureau: false,
      },
      currentPage: 1,
      pagesize: 10,
      bureauList: [],
      bureauTable: [],
      regionId: JSON.parse(sessionStorage.getItem("regionInfo")).regionId, // root用户所在地区
      departmentForm: {
        departmentId: "",
        departmentName: "",
        regionId: "", //添加的单位所在地区
        level: 0,
        leader: "",
        username: "", // 局级管理账号
        remarks: "",
      },
      // 延时器
      t: "",
    };
  },
  name: "BureauManage",
  components: { RegionSelect },
  methods: {
    // 切换每页显示数据
    handleSizeChange(val) {
      this.pagesize = val;
      // console.log(`每页 ${val} 条`);
    },
    // 切换页面
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(`当前页: ${val}`);
    },
    handleAddBureau() {
      this.departmentForm = this.$options.data().departmentForm;
      this.showableComp.addBureau = true;
    },
    handleEdit(index, row) {
      clearTimeout(this.t);
      this.departmentForm = this.$options.data().departmentForm;
      this.departmentForm = row;
      // 延迟200ms
      this.t = setTimeout(() => {
        this.$refs.regionSelect.acceptId(row.regionId);
      }, 200);
      this.showableComp.addBureau = true;
    },
    doCancel() {
      this.showableComp.addBureau = false;
    },
    /**
     * @description 查询地区下的所有单位
     * @function POST /bureau/search
     * 
     * @param {int} regionId 地区ID
     * 
     * @returns bureauList, 其中每一项包含departmentId单位编号,departmentName单位名称,regionId所属地区,level机构级别,leaderId领导,username管理员账号,remarks备注
     */
    searchBureau() {
      post("/bureau/search", this.regionId).then(res => {
        if (res.code == 200) {
          this.bureauList = JSON.parse(res.data.bureauList);
        }
      });
    },
    /**
     * @description 添加单位，如果没有username属性则默认创建一个username=userId的局级管理账号，并赋予rool权限100
     * @function POST /bureau/add
     * 
     * @param {int} regionId 地区ID
     * @param {String} departmentName 单位名称
     * @param {int} level 层级，局级单位均为0
     * @param {String} remarks 备注
     * @param {int} username 局级管理用户名
     * 
     * @returns username局级管理登录账号, departmentId单位Id
     */
    addBureau() {
      console.log(this.departmentForm);
      post("/bureau/add", JSON.stringify(this.departmentForm)).then(res => {
        if (res.code == 200) {
          if (this.departmentForm.username == "") {
            this.departmentForm.username = res.data.username;
          }
          this.showableComp.addBureau = false;
          this.departmentForm.departmentId = res.data.departmentId;
          this.bureauList.push(this.departmentForm);
        }
      });
    },
    /**
     * @description 保存单位信息
     * @function POST /bureau/save
     * 
     * @param {String} departmentId 单位Id
     * @param {String} departmentName 单位名称
     * @param {String} remarks 备注
     * @param {int} username 局级管理用户名
     */
    saveBureau() {
      let data = {
        departmentId: this.departmentForm.departmentId,
        departmentName: this.departmentForm.departmentName,
        remarks: this.departmentForm.remarks,
        username: this.departmentForm.username,
      }
      post("/bureau/save", JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          this.showableComp.addBureau = false;
        }
      });
    },
    /**
     * @description 删除单位
     * @function POST /bureau/delete
     * 
     * @param {int} departmentId 单位ID
     */
    deleteBureau(index, row) {
      post("/bureau/delete", row.departmentId).then(res => {
        if (res.code == 200) {
          this.bureauList.splice(index, 1);
        }
      });
    },
    // 点击确定提交数据
    doSubmit() {
      if (this.departmentForm.departmentId == "") {
        // 新增
        this.addBureau();
      } else {
        // 修改
        this.saveBureau();
      }
    },
    handleReset(index, row) {
      console.log(row);
      post("/password/reset", JSON.stringify({ userId: row.managerId })).then((res) => {

      });
    }
  },
  created() {
    this.bureauTable = bureauTable;
    this.searchBureau();
  },
};